









































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  Project,
  saveProjectCsv,
  getAllProjects,
  suspendProject,
  closeProject,
  SuspendProjectCommand,
  GetProjectsQuery,
  CloseProjectCommand
} from "@/api/project-api";
import { formatShort } from "@/helpers/date-helper";

import AppHeader from "./AppHeader.vue";

import UploadFileSpec from "@/models/specs/UploadFileSpec";
// import { ServiceArise, getUserAriseServices } from "../api/service-api";
import VProjectList, { IProjectListItem } from "@/components/VProjectList.vue";

import VToolbar from "@/components/V-Toolbar.vue";
import SearchProjectBar from "../components/SearchProjectBar.vue";
import { getProjectStatus, isProjectStatus } from "@/models/project-status";

@Component({
  components: {
    VToolbar,
    AppHeader,
    VProjectList,
    SearchProjectBar
  }
})
export default class ProjectListPage extends Vue {
  closedProjectVisible: boolean = false;
  isLoading: boolean = false;

  // TODO: まだ使ってない
  //   private roles: ServiceArise[] = [];

  private projects: Project[] = [];

  get service() {
    return this.$store.state.service;
  }

  get toggleButtonLabel() {
    if (this.closedProjectVisible) {
      return "終了した現場を表示する";
    }
    return "終了した現場を非表示にする";
  }

  get items(): IProjectListItem[] {
    return this.getVisibleProjects().map(ListItem);
  }

  /**
   * 表示する現場を取得する
   */
  private getVisibleProjects() {
    if (!this.closedProjectVisible) {
      return this.projects.filter(p => p.status !== "施工終了");
    }
    return this.projects;
  }

  // TODO: まだ使ってない
  //   public created() {
  //     this.initServiceRoles();
  //   }

  @Watch("$route", { immediate: true })
  onRouteChanged() {
    this.initProjectList();
  }

  get query(): GetProjectsQuery {
    const status = String(this.$route.query.status || "");
    return {
      keyword: String(this.$route.query.keyword || ""),
      client: String(this.$route.query.client || ""),
      status: isProjectStatus(status) ? status : undefined
    };
  }

  async uploadCsv(files: FileList) {
    if (!files.length) return;
    const spec = new UploadFileSpec();
    if (!spec.isSatisfied(files[0])) {
      alert(spec.errors);
      return;
    }
    this.isLoading = true;
    const data = new FormData();
    data.append("csv", files[0]);
    try {
      await saveProjectCsv(data);
      alert("アップロードが完了しました。");
    } catch (e) {
      alert((e as string[]).join("\n"));
      return;
    } finally {
      this.isLoading = false;
    }
    this.initProjectList();
  }

  /**
   * 現場を検索する
   * @param query
   */
  search(query: Record<string, string>) {
    this.$router.push({ query });
  }

  async toggle() {
    this.closedProjectVisible = !this.closedProjectVisible;
  }

  private async initProjectList() {
    this.projects = await getAllProjects(this.query);
  }

  // TODO: まだ使ってない
  //   private async initServiceRoles() {
  //     this.roles = await getUserAriseServices();
  //   }

  async suspend(command: SuspendProjectCommand) {
    let res = await suspendProject(command);
    let targetPrj = this.projects.filter(p => command.id == p.projectId)[0];
    targetPrj.status = getProjectStatus(res.status);
  }

  async close(command: CloseProjectCommand) {
    let res = await closeProject(command);
    let targetPrj = this.projects.filter(p => command.id == p.projectId)[0];
    targetPrj.status = getProjectStatus(res.status);
    targetPrj.closed = command.closed;
  }
}

/**
 * 一覧の項目に変換する
 */
function ListItem(project: Project): IProjectListItem {
  return {
    project: {
      id: String(project.projectId),
      name: project.name,
      icon: project.icon
    },
    place: project.address,
    client: {
      company: project.client ? project.client.company.name : "",
      staff: project.clientStaff ? project.clientStaff.name : ""
    },
    createdAt: formatShort(project.created),
    status: project.status,
    _rowVariant: project.closed ? "secondary" : ""
  };
}
